export default {
  BKSP: 8,
  ESC: 27,
  ENTER: 13,
  TAB: 9,
  SPACE: 32,

  TOP: 38,
  RIGHT: 39,
  BOTTOM: 40,
  LEFT: 37,
};



// WEBPACK FOOTER //
// ./src/misc/keys.js